import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import { PedidoAlarmeProvider } from './context/PedidoAlarmeContext';
import { CarrinhoProvider } from './context/CarrinhoContext';
import { ClienteAuthProvider } from './context/ClienteAuthContext';
import './styles/global.css';

import Login          from './pages/Login';
import MasterDashboard from './pages/master/Dashboard';
import MasterEmpresas  from './pages/master/Empresas';
import MasterPedidos   from './pages/master/Pedidos';
import MasterUsuarios  from './pages/master/Usuarios';
import MasterLogsAcesso from './pages/master/LogsAcesso';
import MasterApiDocs   from './pages/master/ApiDocs';
import AdminDashboard      from './pages/admin/Dashboard';
import AdminPedidos        from './pages/admin/Pedidos';
import AdminConfiguracoes  from './pages/admin/Configuracoes';
import AdminProdutos   from './pages/admin/Produtos';
import AdminProdutoForm from './pages/admin/ProdutoForm';
import AdminCategorias from './pages/admin/Categorias';
import { AdminClientes, AdminRelatorios } from './pages/admin/ClientesRelatorios';
import Cardapio        from './pages/cliente/Cardapio';
import Checkout        from './pages/cliente/Checkout';
import Acompanhar      from './pages/cliente/Acompanhar';
import { Termos, Privacidade } from './pages/cliente/Termos';
import LoginCliente    from './pages/cliente/LoginCliente';
import MinhaConta      from './pages/cliente/MinhaConta';
import EsqueciSenha   from './pages/cliente/EsqueciSenha';
import RedefinirSenha from './pages/cliente/RedefinirSenha';

function RequireAuth({ children, perfil }) {
  const { usuario, loading } = useAuth();
  if (loading) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ width: 36, height: 36, border: '3px solid #eee', borderTopColor: '#FF6B35',
        borderRadius: '50%', animation: 'spin .7s linear infinite' }} />
    </div>
  );
  if (!usuario) return <Navigate to="/login" replace />;
  if (perfil && usuario.perfil !== perfil) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <PedidoAlarmeProvider>
        <ClienteAuthProvider>
        <CarrinhoProvider>
          <Toaster position="top-right" toastOptions={{
            style: { fontFamily: "'Sora', sans-serif", fontSize: '.875rem', borderRadius: '10px' },
          }} />
          <Routes>
            {/* Público */}
            <Route path="/login"                  element={<Login />} />
            <Route path="/acompanhar/:pedido_id"  element={<Acompanhar />} />
            <Route path="/pagina/termos"          element={<Termos />} />
            <Route path="/pagina/privacidade"     element={<Privacidade />} />
            <Route path="/"                       element={<Navigate to="/login" replace />} />

            {/* Cliente final */}
            <Route path="/cliente/login"                    element={<LoginCliente />} />
            <Route path="/cliente/conta"                    element={<MinhaConta />} />
            <Route path="/cliente/esqueci-senha"            element={<EsqueciSenha />} />
            <Route path="/cliente/redefinir-senha/:token"   element={<RedefinirSenha />} />

            {/* Admin Master */}
            <Route path="/master"          element={<RequireAuth perfil="master"><MasterDashboard /></RequireAuth>} />
            <Route path="/master/empresas" element={<RequireAuth perfil="master"><MasterEmpresas /></RequireAuth>} />
            <Route path="/master/pedidos"  element={<RequireAuth perfil="master"><MasterPedidos /></RequireAuth>} />
            <Route path="/master/usuarios" element={<RequireAuth perfil="master"><MasterUsuarios /></RequireAuth>} />
            <Route path="/master/logs-acesso" element={<RequireAuth perfil="master"><MasterLogsAcesso /></RequireAuth>} />
            <Route path="/master/api-docs" element={<RequireAuth perfil="master"><MasterApiDocs /></RequireAuth>} />

            {/* Admin Empresa */}
            <Route path="/admin"            element={<RequireAuth perfil="admin_empresa"><AdminDashboard /></RequireAuth>} />
            <Route path="/admin/pedidos"    element={<RequireAuth perfil="admin_empresa"><AdminPedidos /></RequireAuth>} />
            <Route path="/admin/produtos"   element={<RequireAuth perfil="admin_empresa"><AdminProdutos /></RequireAuth>} />
            <Route path="/admin/produtos/novo"        element={<RequireAuth perfil="admin_empresa"><AdminProdutoForm /></RequireAuth>} />
            <Route path="/admin/produtos/:id/editar"  element={<RequireAuth perfil="admin_empresa"><AdminProdutoForm /></RequireAuth>} />
            <Route path="/admin/categorias" element={<RequireAuth perfil="admin_empresa"><AdminCategorias /></RequireAuth>} />
            <Route path="/admin/clientes"   element={<RequireAuth perfil="admin_empresa"><AdminClientes /></RequireAuth>} />
            <Route path="/admin/relatorios"    element={<RequireAuth perfil="admin_empresa"><AdminRelatorios /></RequireAuth>} />
            <Route path="/admin/configuracoes" element={<RequireAuth perfil="admin_empresa"><AdminConfiguracoes /></RequireAuth>} />

            {/* Loja pública da empresa — fica por último: só casa quando nenhuma rota fixa acima combina */}
            <Route path="/:empresa_id"          element={<Cardapio />} />
            <Route path="/:empresa_id/checkout" element={<Checkout />} />

            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </CarrinhoProvider>
        </ClienteAuthProvider>
        </PedidoAlarmeProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
